import Modal from "components/Modal/Modal";
import { selectState, setAllItemsModal } from "../outputSlice";
import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";

interface IProps {
  onSubmitAll: () => void; // Expect two arguments
  setClickOutsideActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const ReturnAllItemsModal = ({
  onSubmitAll,
  setClickOutsideActive,
}: IProps) => {
  const { allItemsModal } = useSelector(selectState);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setAllItemsModal(false));
    setClickOutsideActive(true);
  };

  const handleSubmitClick = () => {
    onSubmitAll();
    close();
  };

  return (
    <Modal
      isOpen={allItemsModal}
      onClose={close}
      onClick={handleSubmitClick}
    >
      <p className="info-msg">
        <b>Pažnja! Ova operacije ne može se vratiti nazad. <br /> Ona kreira novu
          otpremnicu i trebovanje sa negativnim <br /> količinama i koristi se
          samo kada je selektovana otpremnica i <br /> trebovanje knjigovodstveno razduženo i ne može se menjati.</b>
      </p>
    </Modal>
  );
};

export default ReturnAllItemsModal;
